import styled, { css } from 'styled-components';

export const NightShiftAvatarStyled = styled.div`
  position: relative;
`;

export const AvatarTypeIndicatorStyled = styled.span`
  ${({ theme }) => css`
    position: absolute;
    bottom: 0;
    right: -${theme.spacings[400]};
    padding-right: ${theme.spacings[200]};
    padding-left: ${theme.spacings[200]};
    padding-top: ${theme.spacings[100]};
    border: 1px solid ${theme.colors.white};
    border-radius: ${theme.radii[300]};
    background-color: ${theme.colors.black};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes[100]};
  `}
`;
